import { Injectable, Provider } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { OfferClient, OfferGetQuery, OfferGetQueryResult, OfferListGetQuery, OfferListGetQueryResult } from '../../INTEGRA_Shop_Client';
import { IOfferApiService, IOfferApiServiceToken } from './offer-api-service.interface';
import { BasicError } from 'projects/shared/lib/error/basic-error';

@Injectable({
  providedIn: 'root'
})
export class OfferApiService implements IOfferApiService {

  constructor(
    private offerClient: OfferClient,
  ) { }

  public async offerListGetAsync(loadReferences: boolean, offerDateMinimum: Date | undefined): Promise<OfferListGetQueryResult> {
    let query = new OfferListGetQuery({
      loadReferences: loadReferences,
      offerDateMinimum: offerDateMinimum
    });
    return await firstValueFrom(this.offerClient.offerListGet(query));
  }

  public async offerGetByDidAsync(integraBelegDid: string | undefined): Promise<OfferGetQueryResult> {
    let hasIntegraDid: boolean = integraBelegDid != undefined && integraBelegDid.length > 0;

    if (hasIntegraDid == false) {
      // ToDo: decide whether we should throw an exception... OR get an empty result...
      throw new BasicError("Missing query parameter in offerGetByDidAsync");
      // return new OfferGetQueryResult();
    }

    let query = new OfferGetQuery({
      integraBelegDid: integraBelegDid
    });

    return await firstValueFrom(this.offerClient.offerGet(query));
  }

  public async offerGetbyNrAsync(webshopOfferNumber: string | undefined, integraOfferNumber: string | undefined): Promise<OfferGetQueryResult> {
    let query = new OfferGetQuery();

    if (webshopOfferNumber) {
      query.webshopOfferNumber = webshopOfferNumber;
    }

    if (integraOfferNumber) {
      query.integraOfferNumber = integraOfferNumber;
    }

    if (!query) {
      throw new BasicError("Missing query parameter in offerGet");
    }

    return await firstValueFrom(this.offerClient.offerGet(query));
  }

}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const OfferApiServiceProvider: Provider[] = [
  { provide: OfferClient },
  { provide: IOfferApiServiceToken, useExisting: OfferApiService }
];
